import React, { useId } from "react";
import { Modal as ModalResponsive } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import "./modal.css";

const Modal = ({
  id,
  display,
  size = "md",
  title,
  fullMobile,
  hiddeCloseButton,
  onClose,
  onCloseCallback,
  icon,
  titleVariant = "default",
  headerClassName = "",
  children,
}) => {
  const defaultId = useId();
  const modalId = id ?? defaultId;

  const handleClose = () => {
    if (onClose) onClose();
    if (onCloseCallback) onCloseCallback();
  };

  return (
    <ModalResponsive
      modalId={modalId}
      open={!!display}
      onClose={handleClose}
      center
      showCloseIcon={!hiddeCloseButton}
      classNames={{
        modal: `casvi-modal modal-size-${size} ${fullMobile ? "full-mobile" : ""}`,
        overlay: "casvi-modal-overlay",
      }}
    >
      {(title || icon) && (
        <div className={`modal-header ${headerClassName}`}>
          {icon && <span className="modal-icon">{icon}</span>}
          {title && <h2 className={`modal-title title-${titleVariant}`}>{title}</h2>}
        </div>
      )}
      <div className="modal-body">{children}</div>
    </ModalResponsive>
  );
};

export default Modal;
